<template>
  <div class="modal-overlay" @click.self="$emit('close')">
    <div class="modal-box">
      <button class="close" @click="$emit('close')">×</button>

      <h2>{{ $t("message.traveler_model_title") }}</h2>
      <p class="subtitle">
        {{ $t("message.traveler_model_description") }}
      </p>

      <!-- SUCCESS MESSAGE -->
      <p v-if="successMessage" style="color: green; text-align:center;">
        {{ successMessage }}
      </p>

      <!-- ERROR MESSAGE -->
      <p v-if="errorMessage" style="color: red; text-align:center;">
        {{ errorMessage }}
      </p>

      <form @submit.prevent="submitForm">
        <label>{{ $t("message.full_name") }}</label>
        <input type="text" v-model="form.full_name" :placeholder="$t('message.full_name')"  required />

        <label>{{ $t("message.email_id") }}</label>
        <input type="email" v-model="form.email_id" :placeholder="$t('message.email_id')"  required />

        <label>{{ $t("message.phone_number") }}</label>
        <input type="text" v-model="form.phone_number" placeholder="+52 (xx) xxxx-xxxx" required />

        <label>{{ $t("message.city") }}</label>
        <input type="text" v-model="form.city" :placeholder="$t('message.city')" required />

        <button type="submit" class="submit-btn" :disabled="loading">
          {{ loading ? $t("message.sending") : $t("message.get_early_access") }}
        </button>
      </form>

      <p class="footer-text">
        {{ $t("message.model_footer_text") }}
      </p>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { apiCall } from "@/services/api";

const form = ref({
  full_name: "",
  email_id: "",
  phone_number: "",
  city: ""
});

const loading = ref(false);
const successMessage = ref("");
const errorMessage = ref("");

const submitForm = async () => {
  loading.value = true;
  successMessage.value = "";
  errorMessage.value = "";

  const result = await apiCall(
    "https://api.farrther.com/admin/catalogs/mail/websitenotificationtravler",
    "POST",
    form.value
  );

  loading.value = false;

  if (result.ok) {
    // 👇 PRINT RESPONSE DATA HERE
    console.log("API Response:", result.data);

    successMessage.value = "Travler registration successful!";

      //successMessage.value =
      //result.data.message || "Mail sent successfully!";

    // Clear form
    form.value = {
      full_name: "",
      email_id: "",
      phone_number: "",
      city: ""
    };

  } else {
    console.log("API Error:", result.data);

    errorMessage.value =
      result.data.message || "Something went wrong!";
  }
};
</script>



<style scoped>
/* Overlay */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Modal box */
.modal-box {
  background: #ffffff;
  color: #000;
  width: 100%;
  max-width: 520px;
  padding: 40px;
  border-radius: 20px;
  position: relative;
}

/* Close button */
.close {
  position: absolute;
  right: 20px;
  top: 16px;
  font-size: 26px;
  background: none;
  border: none;
  cursor: pointer;
}

/* Text */
h2 {
  text-align: center;
  margin-bottom: 10px;
}

.subtitle {
  text-align: center;
  color: #555;
  margin-bottom: 30px;
}

/* Form */
form label {
  display: block;
  margin-bottom: 6px;
  font-weight: 500;
}

form input {
  width: 100%;
  padding: 14px;
  border-radius: 10px;
  border: 1px solid #ccc;
  margin-bottom: 18px;
  font-size: 15px;
}

.submit-btn {
  width: 100%;
  padding: 16px;
  background: #163c36;
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 16px;
  cursor: pointer;
  margin-top: 10px;
}

.footer-text {
  text-align: center;
  font-size: 13px;
  margin-top: 20px;
  color: #666;
}
</style>
